import { Box, IconButton, Stack, Text } from "@chakra-ui/core";
import React, { useState } from "react";
import demoResume from "../../../../static/assets/PDFs/demoResume.pdf";
import { Document, Page } from "react-pdf";

function ResumeTabWrapper() {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }
  function changePage(offset) {
    setPageNumber((prevPageNumber) => prevPageNumber + offset);
  }
  function previousPage() {
    changePage(-1);
  }

  function nextPage() {
    changePage(1);
  }
  return (
    <Box
      m="3"
      backgroundColor="#eeeeee"
      p="5"
      borderRadius="1em"
      boxShadow="md"
    >
      <Text fontSize="lg" mb="3" fontWeight="600">
        Resume
      </Text>
      <Document
        file={demoResume}
        onLoadSuccess={onDocumentLoadSuccess}
        className="pdf-viewer"
      >
        <Page pageNumber={pageNumber} />
      </Document>
      <Stack align="center">
        <Text>
          Page {pageNumber || (numPages ? 1 : "--")} of {numPages || "--"}
        </Text>
        <Stack isInline>
          <IconButton
            icon="chevron-left"
            onClick={previousPage}
            isDisabled={pageNumber <= 1}
          />
          <IconButton
            icon="chevron-right"
            onClick={nextPage}
            isDisabled={pageNumber >= numPages}
          />
        </Stack>
      </Stack>
    </Box>
  );
}

export default ResumeTabWrapper;
